import { z } from 'zod';
import { notificationTypesSchema, } from '../index.js';
const MemberSchema = z.object({
    email: z.string().email(),
    role: z.enum(['ADMIN', 'MANAGER', 'MEMBER']),
});
export const organizationMemberApiRoutes = {
    read: {
        method: 'GET',
        path: '/organization/:organizationId/member/:membershipId',
        output: {},
    },
    list: {
        method: 'GET',
        path: '/organization/:organizationId/members',
        output: {},
        q: z
            .object({
            status: z.array(z.enum(['ACTIVE', 'LEFT', 'REMOVED'])).optional(),
        })
            .optional(),
    },
    update: {
        method: 'POST',
        path: '/organization/:organizationId/member/:membershipId',
        input: z.object({
            role: z.enum(['ADMIN', 'MANAGER', 'MEMBER']),
        }),
        output: {},
    },
    notifications: {
        method: 'GET',
        path: '/organization/:organizationId/member/:membershipId/notifications',
        output: {},
        q: z.object({
            unreadOnly: z.boolean().optional(),
            // the cursor will be the createdAt of the last notification in the list
            createdAfter: z.string().optional(),
        }),
    },
    notificationsMarkRead: {
        method: 'POST',
        path: '/organization/:organizationId/member/:membershipId/notifications/toggle-read',
        input: z.object({ notificationIds: z.array(z.string()) }),
        output: {},
    },
    updateNotifications: {
        method: 'POST',
        path: '/organization/:organizationId/member/:membershipId/notifications',
        input: notificationTypesSchema.partial(),
        output: {},
    },
    inviteMember: {
        method: 'POST',
        path: '/organization/:organizationId/invitation',
        input: z.object({
            members: z.array(MemberSchema),
        }),
        output: {},
    },
    inviteRead: {
        method: 'GET',
        path: '/organization/:organizationId/invitation/:inviteId',
        output: {},
    },
    inviteList: {
        method: 'GET',
        path: '/organization/:organizationId/invitations',
        output: {},
    },
    invitationResend: {
        method: 'POST',
        path: '/organization/:organizationId/invitation/:inviteId/resend-invite',
        output: {},
    },
    invitationAccept: {
        method: 'POST',
        path: '/organization/invitation/:inviteKey/accept',
        output: {},
    },
    invitationDecline: {
        method: 'DELETE',
        path: '/organization/invitation/:inviteKey',
        output: {},
    },
    invitationRescind: {
        method: 'DELETE',
        path: '/organization/:organizationId/invitation/:inviteId',
        output: {},
    },
    invitationUpdate: {
        method: 'POST',
        path: '/organization/:organizationId/invitation/:inviteId',
        input: z.object({
            role: z.enum(['ADMIN', 'MANAGER', 'MEMBER']),
        }),
        output: {},
    },
    memberDismiss: {
        method: 'DELETE',
        path: '/organization/:organizationId/membership/:membershipId',
        output: {},
    },
    memberLeave: {
        method: 'DELETE',
        path: '/organization/:organizationId/member/:membershipId/leave',
        output: {},
    },
    inviteCheck: {
        method: 'GET',
        path: '/organization/invitation/:inviteKey/check',
        output: {},
    },
};
//# sourceMappingURL=organization-member-api-routes.js.map